(function() {
  window.traitService = {
    get() {
      return axios.get('/api/trait/get.php');
    },
    save(data) {
      return axios.post('/api/trait/save.php', data);
    }
  }
})();
